import { Check } from "lucide-react";
import { useT } from "@/i18n/LangProvider";
import { useQuoteHref } from "@/i18n/routing";

export default function Offer() {
  const { t } = useT();
  const quoteHref = useQuoteHref();
  const bullets = t("offer.bullets") || [];
  const checklist = t("offer.checklist") || [];

  return (
    <section
      id="oferta"
      data-testid="offer-section"
      className="section"
      style={{ background: "var(--navy-light)" }}
    >
      <div className="section-inner">
        <p className="eyebrow fade-up">{t("offer.eyebrow")}</p>
        <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl mt-4 mb-16 max-w-4xl fade-up">
          {t("offer.title1")}{" "}
          <em className="text-[color:var(--gold-light)]">
            {t("offer.title_em")}
          </em>
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20">
          <div className="fade-up">
            <p className="font-sans-brand text-[color:var(--muted-white)] text-lg leading-relaxed mb-8">
              {t("offer.intro")}
            </p>

            <ul className="space-y-4">
              {bullets.map((b, i) => (
                <li
                  key={i}
                  className="flex gap-4 font-sans-brand text-[color:var(--white)]"
                  data-testid={`offer-bullet-${i}`}
                >
                  <span className="text-[color:var(--gold-light)] font-bold select-none mt-1">
                    —
                  </span>
                  <span className="leading-relaxed">{b}</span>
                </li>
              ))}
            </ul>
          </div>

          <div
            className="card-navy fade-up p-10"
            data-testid="offer-price-card"
            style={{
              background: "var(--navy-deep)",
              borderLeft: "2px solid var(--gold)",
            }}
          >
            <p className="font-mono-brand text-[color:var(--gold-light)] text-xs mb-3">
              {t("offer.card_label")}
            </p>
            <p className="font-serif text-2xl md:text-3xl leading-tight text-[color:var(--white)] mb-8">
              {t("offer.card_headline")}
            </p>

            <div className="divider-gold mb-8" />

            <ul className="space-y-3 mb-10">
              {checklist.map((c, i) => (
                <li
                  key={i}
                  className="flex gap-3 items-start font-sans-brand text-[color:var(--white)] text-sm"
                  data-testid={`offer-checklist-${i}`}
                >
                  <Check
                    className="w-4 h-4 text-[color:var(--gold-light)] mt-1 flex-shrink-0"
                    strokeWidth={2.2}
                  />
                  <span>{c}</span>
                </li>
              ))}
            </ul>

            <a
              href={quoteHref}
              className="btn-pill btn-pill-gold w-full"
              data-testid="offer-cta"
            >
              {t("offer.cta")}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
